<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 8.84A1 1 0 0018 8h-1.78a4.48 4.48 0 00.28-1.5 4.5 4.5 0 00-9 0A4.48 4.48 0 007.78 8H6a1 1 0 00-1 .84l-2 12A1 1 0 004 22h16a1 1 0 001-1.16zM9.5 6.5a2.5 2.5 0 015 0A2.46 2.46 0 0114 8h-4a2.46 2.46 0 01-.5-1.5zM5.18 20l1.67-10h10.3l1.67 10z"/></svg>